import { images } from '../../constants/images';
import Sprite from '../sprites/sprite';

export const SarkarSection = () => {
  return (
    <section className="relative mt-20 w-full flex flex-col sm:flex-row justify-center items-center">
      <img
        loading="lazy"
        src={images['Sarkar']}
        alt="Sant Naam Deo Ji Maharaj"
        className="object-cover object-[50%_60%] h-[480px] sm:h-[560px] md:h-[640px] w-full sm:max-w-[50%] select-none pointer-events-none"
      />
      <div className="flex flex-col w-full px-6 xs:px-9 m-auto mt-8 sm:mt-0 sm:m-[unset] sm:w-[50%] md:px-16 items-center sm:items-start">
        <Sprite name="quote" width="28" height="21" className="w-7 h-5" />
        <h2 className="font-display font-bold text-center sm:text-left text-2xl w-[90%] md:w-[500px] md:text-3xl lg:text-4xl mt-6 leading-tight">
          The silence within us opens up the door to the universe to begin conversing with
          us.
        </h2>
        <p className="font-bold italic font-display mt-7 sm:text-lg text-center sm:text-left">
          Sant Naam Deo Ji Maharaj
        </p>
        <p className="font-serif text-sm text-center sm:text-left sm:text-base">
          International Convenor of Vihangam Yog
        </p>
      </div>
      <div className="h-5/6 bg-gray-100 w-full top-1/2 -translate-y-1/2 left-0 absolute -z-10" />
    </section>
  );
};
